$(document).ready(function() {
    var winH = $(window).height();
    //3D영역(canvas) 3:4 비율 사이즈 맞추기
    $(window).on('resizeend',function(){
        var screenW = $(window).width() - 16;//16은 .cto-area > margin-left,right
        if(self.isPubl){
            screenW = self.$homeSpace.width() - 16;
        }
        //높이 기준으로 비율 맞추기 ( 3 : 4 )
        var ctoAreaH = (winH - 8) - $('.fixed-cont').height(); //8은 .cto-area > margin-top
        var ctoAreaW = ctoAreaH - ctoAreaH/4;
        //계산된 넓이가 화면 넓이보다 크면 넓이 기준으로 비율 맞추기
        if(screenW < ctoAreaW){
            ctoAreaW = screenW;
            ctoAreaH = screenW + screenW/3; 
        }
        $('.cto-area').addClass('border').css('width',ctoAreaW).css('height',ctoAreaH);
    }).on('load',function(){
        $(window).trigger('resizeend');
    }).trigger('resizeend');

    // 제품 핏 (html/3DSPACE/3D-sub04.html) > 모바일 키패드 올라올때 입력창 키패드에 붙치기 테스트 코드
    // 다른 예제: https://codepen.io/sooh/pen/wvmONQv 
    var keys = {37: 1, 38: 1, 39: 1, 40: 1};
    function preventDefault(e) {
        e.preventDefault();
    }
    function preventDefaultForScrollKeys(e) {
        if (keys[e.keyCode]) {
            preventDefault(e);
            return false;
        }
    }
    // modern Chrome requires { passive: false } when adding event
    var supportsPassive = false;
    try {
        window.addEventListener("test", null, Object.defineProperty({}, 'passive', {
            get: function () { supportsPassive = true; }
        }));
    } catch(e) {}
    var wheelOpt = supportsPassive ? { passive: false } : false;
    var wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';
    // call this to Disable
    function disableScroll() {
        window.addEventListener('DOMMouseScroll', preventDefault, false); // older FF
        window.addEventListener(wheelEvent, preventDefault, wheelOpt); // modern desktop
        window.addEventListener('touchmove', preventDefault, wheelOpt); // mobile
        window.addEventListener('keydown', preventDefaultForScrollKeys, false);
        $('body, html, .wrap').add(document).addClass('scrollDisable').on('scroll.space3d touchmove.space3d mousewheel.space3d', function(e){
            e.preventDefault();
            return false;
        });
    }
    // call this to Enable
    function enableScroll() {
        window.removeEventListener('DOMMouseScroll', preventDefault, false);
        window.removeEventListener(wheelEvent, preventDefault, wheelOpt);
        window.removeEventListener('touchmove', preventDefault, wheelOpt);
        window.removeEventListener('keydown', preventDefaultForScrollKeys, false);
        $('body, html, .wrap').add(document).removeClass('scrollDisable').off('scroll.space3d touchmove.space3d mousewheel.space3d');
    }

    var $sizeBoxWrap = $('.size-box-wrap'); // bottom 값을 조정할 요소
    var $fixedCont = $('.fixed-cont');
    var sizeBoxWrapBottom = parseInt($sizeBoxWrap.css('bottom'));
    var timer;
    var inputFocusChk;

    window.visualViewport.addEventListener('resize', function(e) {
        var viewportHeight = window.visualViewport.height;
        var windowHeight = window.innerHeight;
        var isIOS = vcui.detect.isIOS;
        var keyboardHeight = Math.floor(windowHeight - viewportHeight);
        var delay = 50;

        if (!$(document).find('.size-box-wrap:visible').length || isApp() || isIOS) return;
        
        if (!inputFocusChk) delay = 0;

        if (keyboardHeight > $sizeBoxWrap.height()) {
            disableScroll()
            
            clearTimeout(timer);
            timer = setTimeout(function() {
                $sizeBoxWrap.css('bottom', (keyboardHeight + sizeBoxWrapBottom) + 'px');
                $fixedCont.css('bottom', keyboardHeight + 'px');
                inputFocusChk = true;
            }, delay);
        } else {
            enableScroll();

            setTimeout(function() {                
                $sizeBoxWrap.css('bottom', '');
                $fixedCont.css('bottom', '');
                inputFocusChk = false;
            }, 50);
        }
    });

    // 3D 메인 이미지 롤링 이펙트
    function initRollingMarquee() {
        var elems = document.querySelectorAll(".rolling-img");
        if (!elems || elems.length === 0) return;
        
        var i;
        for (i = 0; i < elems.length; i++) {
            var el = elems[i];

            if (el.getAttribute("data-marquee-initialized") === "true") continue;
            el.setAttribute("data-marquee-initialized", "true");

            // 원본 HTML을 두 번 반복하여 롤링 효과 생성
            var originalHTML = el.innerHTML;
            el.innerHTML = originalHTML + originalHTML;

            el.style.display = "flex";
            el.style.flexWrap = "nowrap";
            el.style.alignItems = "center";
            el.style.willChange = "transform";

            // 각 요소별로 롤링 설정 적용
            (function (target) {
                function setup() {
                    var total = target.scrollWidth;
                    var originalWidth = Math.round(total / 2) || target.offsetWidth || 0;
                    if (originalWidth <= 0) return;

                    var distance = "-" + originalWidth + "px";
                    var pxPerSec = 180; // 기본 속도: 초당 180px
                    if (target.classList.contains("rolling-fast")) pxPerSec = 120; // 빠른 롤링
                    if (target.classList.contains("rolling-slow")) pxPerSec = 40;  // 느린 롤링
                    var duration = Math.max(8, Math.round(originalWidth / pxPerSec)); // 최소 8초

                    // reverse 클래스가 있으면 반대로 롤링
                    if (target.classList.contains("reverse")) distance = Math.abs(originalWidth) + "px";

                    target.style.setProperty("--marquee-distance", distance);
                    target.style.setProperty("--marquee-duration", duration + "s");
                    target.classList.add("marquee");
                }
                setTimeout(setup, 50);
                window.addEventListener("load", setup);
            })(el);
        }
    }
    
    var resizeTimer = null;
    function onResize() {
        if (resizeTimer) clearTimeout(resizeTimer);
        resizeTimer = setTimeout(initRollingMarquee, 150);
    }

    if (document.readyState === "complete" || document.readyState === "interactive") {
        setTimeout(initRollingMarquee, 0);
    } else {
        window.addEventListener("DOMContentLoaded", function() {
            initRollingMarquee();
        } );
    }

    window.addEventListener("load", function () {
        initRollingMarquee();
    });
    window.addEventListener("resize", function () {
        onResize();
    });

    window.initRollingMarquee = initRollingMarquee;
});
    